import React from 'react';

const formatTitle = (key) =>
	key
		.replace(/_/g, ' ')
		.replace(/\b\w/g, (char) => char.toUpperCase()).split('Per')[0];

export default function SubscriptionStatisticsUsages({ planUsages, setIsOpenUsageOverviewModal }) {
	if (!planUsages) return null;

	const usageEntries = Object.values(planUsages || {});

	const totalAllowed = usageEntries.reduce(
		(sum, item) => sum + (item.total_allowed || 0),
		0
	);

	const totalConsumed = usageEntries.reduce(
		(sum, item) => sum + (item.total_consumed || 0),
		0
	);

	const totalUsagePercentage =
		totalAllowed > 0
			? Math.round((totalConsumed / totalAllowed) * 100)
			: 0;

	return (
		<div style={{ overflowX: "auto" }}>
			<div
				className="d-flex justify-content-between align-items-center rounded-3 px-2 py-4 my-4"
				style={{ backgroundColor: 'rgba(244, 245, 249, 1)' }}
			>
				<div className="px-3">
					<div className="d-flex gap-4 align-items-center">
						<div className="fs-5 fw-semibold">Usage This Month</div>
					</div>
					<div className="fs-5 fw-light">
						You are using {totalUsagePercentage}% of your limits.
					</div>
				</div>

				{Object.entries(planUsages).map(([key, data]) => {
					return (
						<div
							key={key}
							className="d-flex gap-4 align-items-center"
						>
							<div className="subscription-progress-bar">
								<div
									className="subscription-progress-fill"
									style={{ width: `${data.usage_percentage}%` }}
								></div>
							</div>

							<div>
								<div className="fs-5 fw-light text-dark">
									{formatTitle(key)}
								</div>

								<div className="fs-5 fw-light text-dark">
									{`${data.total_consumed} / ${data.total_allowed}`}
								</div>
							</div>
						</div>
					);
				})}
				<div className=" px-4 fs-4 fw-bold text-primary cursor-pointer" onClick={() => setIsOpenUsageOverviewModal(true)}>View Usages</div>
			</div>
		</div>
	);
}